export default __webpack_public_path__ + "static/media/home-business-services-img04.9bc932aa.jpg";